import React, { useState } from 'react';

const CustomPickList = ({ availableColumns, selectedColumns, onSelectionChange, searchable=false }) => {
    const [searchQueryAvailable, setSearchQueryAvailable] = useState('');
    const [searchQuerySelected, setSearchQuerySelected] = useState('');

    // Move item from available list to selected list
    const moveToSelected = (column) => {
        const newAvailable = availableColumns.filter((col) => col !== column);
        const newSelected = [...selectedColumns, column];
        onSelectionChange(newAvailable, newSelected); // Pass updated lists to parent
    };

    // Move item from selected list to available list
    const moveToAvailable = (column) => {
        const newSelected = selectedColumns.filter((col) => col !== column);
        const newAvailable = [...availableColumns, column];
        onSelectionChange(newAvailable, newSelected); // Pass updated lists to parent
    };

    // Move all available columns to selected columns
    const moveAllToSelected = () => {
        onSelectionChange([], [...selectedColumns, ...availableColumns]); // Append to selected
    };

    // Move all selected columns to available columns
    const moveAllToAvailable = () => {
        onSelectionChange([...availableColumns, ...selectedColumns], []); // Append to available
    };

    // Filter columns based on the search query
    const filteredAvailableColumns = availableColumns.filter((column) =>
        column.toLowerCase().includes(searchQueryAvailable.toLowerCase())
    );

    const filteredSelectedColumns = selectedColumns.filter((column) =>
        column.toLowerCase().includes(searchQuerySelected.toLowerCase())
    );

    return (
        <div className="flex space-x-4">
            <div className="w-1/2">
                <h3 className="text-lg font-medium mb-2">Available Columns</h3>
                
                <ul className="border p-4 rounded-lg h-64 overflow-auto">
                    {searchable && (
                <input
                    type="text"
                    className="border p-2 rounded mb-2 w-full"
                    placeholder="Search columns..."
                    value={searchQueryAvailable}
                    onChange={(e) => setSearchQueryAvailable(e.target.value)}
                />)}
                    {filteredAvailableColumns.map((column) => (
                        <li
                            key={column}
                            className="cursor-pointer hover:bg-gray-200 p-2"
                            onClick={() => moveToSelected(column)} // Single selection
                        >
                            {column}
                        </li>
                    ))}
                </ul>
            </div>

            <div className="flex flex-col justify-center space-y-2">
                <button
                    type="button"
                    className="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600"
                    onClick={moveAllToSelected} // Move all to selected
                >
                    &gt;&gt;
                </button>
                <button
                    type="button"
                    className="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600"
                    onClick={moveAllToAvailable} // Move all to available
                >
                    &lt;&lt;
                </button>
            </div>

            <div className="w-1/2">
                <h3 className="text-lg font-medium mb-2">Selected Columns</h3>
                {/* <input
                    type="text"
                    className="border p-2 rounded mb-2 w-full"
                    placeholder="Search selected columns..."
                    value={searchQuerySelected}
                    onChange={(e) => setSearchQuerySelected(e.target.value)}
                /> */}
                <ul className="border p-4 rounded-lg h-64 overflow-auto">
                    {filteredSelectedColumns.map((column) => (
                        <li
                            key={column}
                            className="cursor-pointer hover:bg-gray-200 p-2"
                            onClick={() => moveToAvailable(column)} // Single deselection
                        >
                            {column}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default CustomPickList;
